import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS } from 'src/app/constants';
import { environment } from 'src/environments/environment';
import { LanguageService } from '../providers/services/language.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'carelflex-configurator';

  constructor(
    private router: Router,
    private languageService: LanguageService,
    private translateService: TranslateService
  ) {
    this.init();
  }

  private async init() {
    // Text translation
    try {
      const lang: string = await this.languageService.getPreferredLanguage();
      if (environment.languages.availables.indexOf(lang) !== -1) {
        this.translateService.use(lang);
      } else {
        this.translateService.use(environment.languages.default);
      }
    } catch (err) {
      this.translateService.use(environment.languages.default);
    }
  }

  showAlerts(): boolean {
    const routes = [
      CONSTANTS.ROUTES.LOGIN,
      `${CONSTANTS.ROUTES.HOME}/${CONSTANTS.ROUTES.ALERTS_VIEW}`
    ];

    return !routes.map(route => `/${route}`).includes(this.router.url);
  }
}
